import React, { useState } from "react";
import { Modal, ModalBody, Button, Spinner, Input, Label } from "reactstrap";
import { IoCloseSharp } from "react-icons/io5";
import toast from "react-hot-toast";
import { uploadProductImage } from "../../firebase/utility";
import { uniqueID } from "../../firebase/utility";

const GetImageUrlModal = ({ modal, toggle }) => {
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadedUrl, setUploadedUrl] = useState("");
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        setFile(selectedFile);
        const objectUrl = URL.createObjectURL(selectedFile);
        setPreviewUrl(objectUrl);
        setUploadedUrl(""); // Reset if a new file is chosen
    };

    const handleUpload = async () => {
        if (!file) {
            toast.error("Please select an image first.");
            return;
        }

        setUploading(true);
        try {
            const uid = uniqueID();
            const imageName = `tmu-${uid}`;

            const url = await uploadProductImage(file, imageName);

            setUploadedUrl(url);
            toast.success("Image uploaded successfully!");
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Failed to upload image.");
        } finally {
            setUploading(false);
        }
    };

    const copyToClipboard = () => {
        if (!uploadedUrl) return;
        navigator.clipboard.writeText(uploadedUrl).then(() => {
            toast.success("URL copied to clipboard!");
        });
    };

    return (
        <Modal isOpen={modal} toggle={toggle} centered size="md" onClosed={() => {
            setFile(null);
            setPreviewUrl(null);
            setUploadedUrl("");
        }}>
            <ModalBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="primary-color m-0 fw-bold">Get Image URL</h5>
                    <IoCloseSharp size={"24"} onClick={toggle} className="pointer text-muted" />
                </div>

                <div className="mb-4">
                    <Label className="fw-bold">Select File</Label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="form-control"
                    />
                </div>

                {previewUrl && (
                    <div className="text-center mb-4">
                        <img
                            src={previewUrl}
                            alt="Preview"
                            className="img-fluid rounded border shadow-sm"
                            style={{ maxHeight: '200px' }}
                        />
                    </div>
                )}

                <div className="d-flex justify-content-end mb-3">
                    <Button
                        color="primary"
                        onClick={handleUpload}
                        disabled={uploading || !file || !!uploadedUrl}
                    >
                        {uploading ? <Spinner size="sm" /> : "Upload Image"}
                    </Button>
                </div>

                {uploadedUrl && (
                    <div className="mt-4 p-3 bg-light border rounded">
                        <label className="fw-bold fs-6 mb-2">Image URL</label>
                        <div className="d-flex gap-2">
                            <Input
                                type="text"
                                value={uploadedUrl}
                                readOnly
                                className="bg-white"
                            />
                            <Button color="secondary" onClick={copyToClipboard} style={{ whiteSpace: 'nowrap' }}>
                                Copy URL
                            </Button>
                        </div>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default GetImageUrlModal;
